import { cx } from '@onbeam/business-styled-system/css';
import { text } from '@onbeam/business-styled-system/patterns';

export const navItemStyles = cx(
  'group',
  text({
    color: 'mono.tertiary',
    pointerEvents: 'all',
    transition: 'colors',
    overflow: 'hidden',
    position: 'relative',

    '&[href]': {
      cursor: 'pointer',
    },
    _hoverFocusActive: {
      color: 'mono.primaryBg',
    },
    '&[target="_blank"]': {
      _before: {
        transition: 'opacity',
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        w: '[1rem]',
        zIndex: 2,
        pointerEvents: 'none',
        bg: '[linear-gradient(270deg, transparent 0%, token(colors.mono.primaryFg) 100%)]',
        opacity: 0,
      },
      _hover: {
        _before: {
          opacity: 1,
        },
      },
    },
  }),
);
